// MF-67 — Code → record lookups for types, severities and categories, so lists/previews can show a severity's
// label + colour (not its raw code) and a category's name. Loads the tenant-wide set once if missing.
import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { loadSeverities } from '../../../../store/actions/journalSeveritiesActions'
import { loadCategories } from '../../../../store/actions/journalCategoriesActions'
import { loadTypes } from '../../../../store/actions/journalTypesActions'

export const useSeveritiesMap = () => {
  const dispatch = useDispatch()
  const list = useSelector((state) => state.journalSeverities?.severities?.list || [])
  useEffect(() => {
    if (!list.length) dispatch(loadSeverities({ limit: 200 }))
    // Load once; severities are tenant-wide and small.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])
  return useMemo(() => new Map(list.map((r) => [r.code, r])), [list])
}

export const useCategories = () => {
  const dispatch = useDispatch()
  const list = useSelector((state) => state.journalCategories?.categories?.list || [])
  useEffect(() => {
    dispatch(loadCategories({ page: 1, limit: 200 }))
  }, [dispatch])
  const byCode = useMemo(() => new Map(list.map((c) => [c.code, c])), [list])
  const byId = useMemo(() => new Map(list.map((c) => [String(c._id), c])), [list])
  return { list, byCode, byId }
}

// Types are tenant-configurable (label + colour + order); records carry the type CODE.
export const useTypes = () => {
  const dispatch = useDispatch()
  const list = useSelector((state) => state.journalTypes?.types?.list || [])
  useEffect(() => {
    if (!list.length) dispatch(loadTypes({ limit: 200 }))
    // Load once; types are tenant-wide and small.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])
  const byCode = useMemo(() => new Map(list.map((s) => [s.code, s])), [list])
  return { list, byCode }
}
